// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2nKL0","label":"styles_label__3_K2C","input":"styles_input__23-_H","error":"styles_error__3XSig"};